import GameWrapperStypes from "./css_modules/GameWrapperStyles.module.css"
import { useTranslation } from "react-i18next";



const GameWrapper = ({ gameState, children }) => {
    const { t } = useTranslation();

    return (
        <div className={GameWrapperStypes.GameWrapper}>
            {gameState && <div className={GameWrapperStypes.gameOverMsg}>{t('gameOver')} </div>}
            {children}
        </div>
    )
}

export default GameWrapper